import { useMemo } from 'react';

import { useStatusContext } from 'pages/Status/context';
import { formatProvider } from 'utils';

interface ActionRequiredHook {
  provider: string;
  isLoading: boolean;
}

export default function useActionRequired(): ActionRequiredHook {
  const { provider, isLoading } = useStatusContext();

  const formattedProvider = useMemo(() => {
    if (!provider) return '';
    if (provider === 'example') return 'example';
    return formatProvider(provider);
  }, [provider]);

  return {
    provider: formattedProvider,
    isLoading,
  };
}
